import service from "../api/services/testService";

export default {
  namespaced: true,
  state: {
    questionsList: {},
    testDetails: {},
    filteredQuestionsList: {},
    defaultLegendsData: {
      answered: 0,
      notAnswered: 0,
      notVisited: 0,
      reviewLater: 0,
      answeredReviewLater: 0,
    },
    subjectQuestionTypeList: [],
    selectedSQTIndex: 0,
    testData: {},
    isTestStarted: false,
    isPastTest: false,
    disableSecondaryAction: false,
  },
  getters: {
    isTestStarted(state) {
      return state.isTestStarted;
    },
    disableSecondaryAction(state) {
      return state.disableSecondaryAction;
    },
    questionsList(state) {
      return state.questionsList;
    },
    testDetails(state) {
      return state.testDetails;
    },
    filteredQuestionsList(state) {
      return state.filteredQuestionsList;
    },
    testData(state) {
      return state.testData;
    },
    subjectQuestionTypeList(state) {
      return state.subjectQuestionTypeList;
    },
    selectedSQTIndex(state) {
      return state.selectedSQTIndex;
    },
    isPastTest(state) {
      return state.isPastTest;
    },
  },
  mutations: {
    updateIsTestStarted(state, payload) {
      state.isTestStarted = payload;
    },
    updateDisableSecondaryAction(state, payload) {
      state.disableSecondaryAction = payload;
    },
    updateTestDetails(state, payload) {
      state.testDetails = payload;
    },
    updateTestData(state, payload) {
      state.testData = payload;
    },
    updateQuestionsList(state, payload) {
      state.questionsList = payload;
    },
    updateFilteredQuestionsList(state, payload) {
      state.filteredQuestionsList = payload;
    },
    updateSelectedQuestionTestData(state, payload) {
      state.selectedQuestionTestData = payload;
    },
    updateSubjectQuestionTypeList(state, payload) {
      state.subjectQuestionTypeList = payload;
    },
    updateSQTLQuestionIndex(state, payload) {
      state.subjectQuestionTypeList[payload.typeIndex].currentQuestionIndex =
        payload.currentQuestionIndex;
    },
    updateSelectedSQTIndex(state, payload) {
      state.selectedSQTIndex = payload;
    },
    setIsPastTest(state, payload) {
      state.isPastTest = payload;
    },
    updateSQTLAnswerCount(state, payload) {
      state.subjectQuestionTypeList[payload.typeIndex].qAnsweredCount =
        payload.qAnsweredCount;
    },
  },
  actions: {
    setTestData(context, data) {
      context.commit("updateTestData", data);
    },
    setSubjectQuestionTypeList(context, data) {
      context.commit("updateSubjectQuestionTypeList", data);
    },
    setFilteredQuestionsList(context, data) {
      context.commit("updateFilteredQuestionsList", data);
    },
    setSelectedSQTIndex(context, data) {
      context.commit("updateSelectedSQTIndex", data);
    },
    setSelectedQuestionIndex(context, data) {
      context.commit("updateSQTLQuestionIndex", data);
    },
    setIsTestStarted(context, data) {
      context.commit("updateIsTestStarted", data);
    },
    setDisableSecondaryAction(context, data) {
      context.commit("updateDisableSecondaryAction", data);
    },
    setAnswerCount(context, data) {
      context.commit("updateSQTLAnswerCount", data);
    },
    getTestList(context, reqData) {
      return service.getTestList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getActiveInstituteList(context, reqData) {
      return service.getActiveInstituteList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    showLoader(status) {
      return new Promise((resolve, reject) => {
        resolve("foo");
      });
    },
    getScheduleTestList(context, reqData) {
      return service.getScheduleTestList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    schedule(context, reqData) {
      return service.schedule(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    share(context, reqData) {
      return service.share(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getLiveStudents(context, reqData) {
      return service.getLiveStudents(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    assignTest(context, reqData) {
      return service.assignTest(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    assignTestStatus(context, reqData) {
      return service.assignTestStatus(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    createTest(context, reqData) {
      return service.createTest(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    updateTestInstructions(context, reqData) {
      return service.updateTestInstructions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getTestPreviewDetails(context, reqData) {
      return service.getTestPreviewDetails(reqData).then((response = {}) => {
        context.commit("updateQuestionsList", response.responseData.questions);
        context.commit("updateTestDetails", response.responseData);
        return response.responseData;
      });
    },
    getLiveTestDetails(context, reqData) {
      return service.getLiveTestDetails(reqData).then((response = {}) => {
        context.commit("updateQuestionsList", response.responseData.questions);
        context.commit("updateTestDetails", response.responseData);
        return response.responseData;
      });
    },
    updateProgressInDB(context, reqData) {
      return service.updateProgressInDB(reqData).then((response = {}) => {
        return response;
      });
    },
    updateHeartBeat(context, reqData) {
      return service.updateHeartBeat(reqData).then((response = {}) => {
        return response;
      });
    },
    getInstructions(context, reqData) {
      return service.getInstructions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getPastTestDetails(context, reqData) {
      return service.getTestPreviewDetails(reqData).then((response = {}) => {
        context.commit("updateQuestionsList", response.responseData.questions);
        context.commit("updateTestDetails", response.responseData);
        return response.responseData;
      });
      // context.commit('updateQuestionsList', testData.responseData.questions);
      // context.commit('updateTestDetails', testData.responseData);
      // return testData.responseData;
    },
    getPastTestList(context, reqData) {
      return service.getPastTestList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getOnlinePastTestList(context, reqData) {
      return service.getOnlinePastTestList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getTestResultsList(context, reqData) {
      return service.getTestResultsList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    remainingTime(context, reqData) {
      return service.remainingTime(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    updateTestName(context, reqData) {
      return service.updateTestName(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getQuestions(context, reqData) {
      return service.getQuestions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    applyBonus(context, reqData) {
      return service.applyBonus(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    reevaluateMarks(context, reqData) {
      return service.reevaluateMarks(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    createDuplicateTest(context, reqData) {
      return service.createDuplicateTest(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    deleteTestById(context, reqData) {
      return service.deleteTestById(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    uploadAndReplaceQuestion(context, reqData) {
      return service.uploadAndReplaceQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    createCustomTest(context, reqData) {
      return service.createCustomTest(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    searchAnotherQuestion(context, reqData) {
      return service.searchAnotherQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    replaceTestQuestion(context, reqData) {
      return service.replaceTestQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getBucketQuestion(context, reqData) {
      return service.getBucketQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    addBucketQuestion(context, reqData) {
      return service.addBucketQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    removeBucketQuestion(context, reqData) {
      return service.removeBucketQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    approveTest(context, reqData) {
      return service.approveTest(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getPastTestTeacher(context, reqData) {
      return service.getPastTestTeacher(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getTestQuestionData(context, reqData) {
      return service.getTestQuestionData(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    deleteTest(context, reqData) {
      return service.deleteTest(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    customTestRetry(context, reqData) {
      return service.customTestRetry(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    checkTestStatus(context, reqData) {
      return service.checkTestStatus(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    createTestForPracticeSession(context, reqData) {
      return service
        .createTestForPracticeSession(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    getTestForPracticeSession(context, reqData) {
      return service
        .getTestForPracticeSession(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    //Integrating add & remove Bookmark API.
    addBookmarkQuestion(context, reqData) {
      return service.addBookmarkQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getQuestionOptions(context,reqData){
      return service.getQuestionOptions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    removeBookmarkQuestion(context, reqData) {
      return service.removeBookmarkQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getBookmarkQuestion(context, reqData) {
      return service.getBookmarkQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getAttemptedQuestions(context, reqData) {
      return service.getAttemptedQuestions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    updateTestForPracticeSession(context, reqData) {
      return service
        .updateTestForPracticeSession(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    improvementAssignmentList(context, reqData) {
      return service
        .improvementAssignmentList(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    improvementAssignmentQueLoad(context, reqData) {
      return service
        .improvementAssignmentQueLoad(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    getTestForImprovementAssignment(context, reqData) {
      return service
        .getTestForImprovementAssignment(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    updateTestForImprovementAssignment(context, reqData) {
      return service
        .updateTestForImprovementAssignment(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    getPracticeSessionList(context, reqData) {
      return service
        .getPracticeSessionList(reqData)
        .then((response = {}) => {
          return response.responseData;
        });
    },
    getTestReportsList(context,reqData) {
			return service.getTestReportsList(reqData).then((response={})=>{
				return response.responseData
			})
		},
    getOnlineTestReportsList(context,reqData) {
      return service.getOnlineTestReportsList(reqData).then((response={})=>{
        return response.responseData
      })
    },
    testAttempted(context,reqData) {
			return service.testAttempted(reqData).then((response={})=>{
				return response.responseData
			})
		},
    getQuesDateAndViewCountOfLastCreQues(context, reqData) {
      return service.getQuesDateAndViewCountOfLastCreQues(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    saveEvent(context,reqData) {
			return service.saveEvent(reqData).then((response={})=>{
				return response.responseData
			})
		},
    getCustomTestCount(context,reqData) {
			return service.getCustomTestCount(reqData).then((response={})=>{
				return response.responseData
			})
		},
    getDownloadedTestCount(context,reqData) {
			return service.getDownloadedTestCount(reqData).then((response={})=>{
				return response.responseData
			})
		},
    
    saveInstituteTestDownload(context, reqData) {
      return service.saveInstituteTestDownload(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    autoSubmit(context,reqData) {
			return service.autoSubmit(reqData).then((response={})=>{
				return response.responseData
			})
		},
    logData(context,reqData) {
			return service.logData(reqData).then((response={})=>{
				return response.responseData
			})
		},
    createMytTest(context,reqData){
      return service.createMytTest(reqData).then((response={})=>{
				return response.responseData
			})
    },
    getMYTTestList(context, reqData) {
      return service.getMYTTestList(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getMYTPreviewDetails(context, reqData) {
      return service.getMYTPreviewDetails(reqData).then((response = {}) => {
        context.commit("updateQuestionsList", response.responseData.questions);
        context.commit("updateTestDetails", response.responseData);
        return response.responseData;
      });
    },
    saveTemplate(context, formData) {
      return service.saveTemplate(formData).then((response = {}) => {
          return response.responseData;
      }).catch((error) => {
          return Promise.reject(error);
      });
  },
  getTemplate(context, reqData) {
    return service.getTemplate(reqData).then((response = {}) => {
      context.commit("updateQuestionsList", response.responseData.questions);
      context.commit("updateTestDetails", response.responseData);
      return response.responseData;
    });
  },
  removeTemplate(context, reqData) {
    return service.removeTemplate(reqData).then((response = {}) => {
      return response.responseData;
    });
  },

    getSimilarQuestions(context, reqData) {
      return service.getSimilarQuestions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getInstituteSimilarQuestions(context, reqData) {
      return service.getInstituteSimilarQuestions(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    replaceQuestion(context, reqData) {
      return service.replaceQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    replaceInstituteQuestion(context, reqData) {
      return service.replaceInstituteQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    uploadAndReplaceMytQuestion(context, reqData) {
      return service.uploadAndReplaceMytQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getQuestionUsageDetails(context, reqData) {
      return service.getQuestionUsageDetails(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    searchAnotherMytQuestion(context, reqData) {
      return service.searchAnotherMytQuestion(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    testCreationLimit(context, reqData) {
      return service.testCreationLimit(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    getTabChangeCount(context, reqData) {
      console.log(reqData);
      return service.getTabChangeCount(reqData).then((response = {}) => {
        return response.responseData;
      });
    },
    getPastTestInstituteList(context, reqData) {
      return service.getPastTestInstituteList(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    deleteScheduleTest(context, reqData) {
      return service.deleteScheduleTest(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    getOmrDetailsTestWise(context, reqData) {
      return service.getOmrDetailsTestWise(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    getUnassessedOmrDetails(context, reqData) {
      return service.getUnassessedOmrDetails(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    deleteOmr(context, reqData) {
      return service.deleteOmr(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    uploadOmr(context, formData) {
      return service.uploadOmr(formData).then((response = {}) => {
          return response.responseData;
      })
    },
    getOmrDetail(context, formData) {
      return service.getOmrDetail(formData).then((response = {}) => {
          return response.responseData;
      })
    },
    getOmrById(context, id) {
      return service.getOmrById(id).then((response = {}) => {
          return response.responseData;
      })
    },
    recycleOmr(context, id) {
      return service.recycleOmr(id).then((response = {}) => {
          return response.responseData;
      })
    },

    getTestDownloadSettings(context, reqData) {
      return service.getTestDownloadSettings(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    downloadTest(context, reqData) {
      return service.downloadTest(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    getDownloadStatus(context, reqData) {
      return service.getDownloadStatus(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    deleteDownloadData(context, reqData) {
      return service.deleteDownloadData(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    getOmrDetailsById(context, id) {
      return service.getOmrDetailsById(id).then((response = {}) => {
          return response.responseData;
      })
    },
    editOmrResponseData(context, reqData) {
      return service.editOmrResponseData(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    importTestResponses(context, formData) {
      return service.importTestResponses(formData).then((response = {}) => {
          return response.responseData;
      })
    },
    downloadResponseTemplate(context, reqData) {
      return service.downloadResponseTemplate(reqData).then((response = {}) => {
          return response.responseData;
      })
    },
    
  },
};
